/**
 * layouts-v2 REST helpers (relational seats/zones — separate from Konva /layouts).
 */
import { getPanelAccessToken } from '../services/apiAuthProvider';
import { apiGet } from '../services/apiClient';

const getApiUrl = () => {
  const base = process.env.REACT_APP_API_URL ?? 'http://localhost:3001';
  return base.replace(/\/$/, '');
};

const parseJson = async (response) => {
  const text = await response.text();
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
};

const request = async (path, options = {}) => {
  const token = getPanelAccessToken();
  const response = await fetch(`${getApiUrl()}/layouts-v2${path}`, {
    ...options,
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
  const data = await parseJson(response);
  if (!response.ok) {
    const message =
      (data &&
        (Array.isArray(data.message) ? data.message.join(', ') : data.message || data.error)) ||
      `API error (${response.status})`;
    const error = new Error(message);
    error.status = response.status;
    error.data = data;
    throw error;
  }
  return data;
};

/** Map editor zone.polygonPoints → API zone.points before save. */
export const mapZonesForSave = (zones = []) =>
  (zones || []).map((zone) => {
    const { polygonPoints, ...rest } = zone;
    return {
      ...rest,
      points: zone.points ?? polygonPoints ?? null,
    };
  });

export const listLayouts = async (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      qs.set(key, String(value));
    }
  });
  const query = qs.toString();
  return request(query ? `?${query}` : '');
};

export const getLayout = async (id) => request(`/${encodeURIComponent(id)}`);

export const createLayout = async (body) =>
  request('', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

export const updateLayout = async (id, body) =>
  request(`/${encodeURIComponent(id)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

export const deleteLayout = async (id) =>
  request(`/${encodeURIComponent(id)}`, { method: 'DELETE' });

/** Venues via existing panel collections API. */
export const listVenues = async () => {
  const res = await apiGet('venues?perPage=500&sort=name&order=ASC');
  if (Array.isArray(res?.data)) return res.data;
  if (Array.isArray(res)) return res;
  if (Array.isArray(res?.venues)) return res.venues;
  return [];
};
